export default class templateImagesBlock {
    constructor() {
        return {
            scope: {
                images: "=",
                template: "="
            },
            restrict: 'E',
            template: require('../../../../views/template/template-images-block.html'),
            controller: ImageBlockCtrl,
            controllerAs: 'img'
        }
    };
};

class ImageBlockCtrl {
    constructor($scope, $filter, Template, Sogeti, ImageBank) {
        this._scope = $scope;
        this._translate = $filter('translate');

        this.imageBankRepo = ImageBank;
        this.templateRepo = Template;
        this.sogeti = Sogeti;

        if (this.sogeti.isSogetiAccount(this._scope.template.account_id)) {
            this.imageTypeMap = {
                1: 'template-thumbnail',
                2: 'page-thumbnail',
                3: 'background'
            };
        } else {
            this.imageTypeMap = {
                1: 'template-thumbnail'
            };
        }

        this._scope.$on('template:images:imageUpdated', (event, imageFile, type, useOriginal) => {
            if (type != 'template-thumbnail') {
                this.uploadImage(imageFile, (image) => {
                    this.updateTemplateImage(image, type);
                });
            } else {
                this.templateRepo.uploadThumbnail(this._scope.template.id, imageFile, useOriginal).then(() => {
                    this._scope.$emit('template:refreshImages');
                });
            }
        });
    }

    getImageByType(typeIdx) {
        if (! this._scope.images || ! this._scope.images.data) {
            return null;
        }

        return this._scope.images.data.filter((image) => {
            return image.type.id == typeIdx;
        })[0];
    };

    getImageIdByType(typeIdx) {
        let image = this.getImageByType(typeIdx);

        return image ? image.image_id : null;
    };

    getTypeMessages(imageType) {
        return {
            header: this._translate('TEMPLATE:EDIT:' + imageType.toUpperCase() + '_HEADER'),
            info: this._translate('TEMPLATE:EDIT:' + imageType.toUpperCase() + '_INFO'),
            dialog_header: this._translate('TEMPLATE:EDIT:' + imageType.toUpperCase() + '_DIALOG_HEADER'),
            dialog_info: this._translate('TEMPLATE:EDIT:' + imageType.toUpperCase() + '_DIALOG_INFO')
        }
    };

    uploadImage(imageFile, callback) {
        this.imageBankRepo.store([imageFile]).then((response) => {
            let image = response.data[0];

            if (callback) {
                return callback(image);
            }
        });
    };

    updateTemplateImage(image, type) {
        angular.forEach(this.imageTypeMap, (imageTypeIdx, index) => {
            if (imageTypeIdx == type) {
                this.templateRepo.updateImage(this._scope.template.id, image.id, index).then(() => {
                    this._scope.$emit('template:refreshImages');

                    if (this.sogeti.isSogetiAccount(this._scope.template.account_id) && type === 'background') {
                        this._scope.$emit('sogeti:background:updated', image);
                    }
                });
            }
        });
    };
}
